import { SliderImplantations } from '@components/slider-implantations/models';
import { kitchenLightMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const sliderImplantationsMock: Block<SliderImplantations> = {
  type: 'slider-implantations',
  data: {
    title: {
      text: `Une cuisine qui [[s'adapte à votre intérieur]]`,
      as: 'span',
    },
    items: [kitchenLightMock, kitchenLightMock, kitchenLightMock],
  },
};
